module.exports = __webpack_public_path__ + "media/images/favicons/asanaadvisors-b3bc666bb4fe2ef1eded5dcd20a924d5a773257d17c98b9e47792b2070309253.ico";